import { pushCallDebugLog } from 'vcs-common';
const CONTAINER_ID = 'zingizi-remote-audio';
export function createRemoteAudioPlayback() {
    const attached = new Map();
    let sinkId;
    const getContainer = () => {
        if (typeof document === 'undefined' || !document.body)
            return null;
        let container = document.getElementById(CONTAINER_ID);
        if (!container) {
            container = document.createElement('div');
            container.id = CONTAINER_ID;
            container.style.display = 'none';
            document.body.appendChild(container);
        }
        return container;
    };
    const applySinkId = (element) => {
        if (!sinkId)
            return;
        const withSink = element;
        if (typeof withSink.setSinkId !== 'function')
            return;
        void Promise.resolve(withSink.setSinkId(sinkId)).catch((error) => {
            console.warn('Failed to set audio output device for remote audio', error);
        });
    };
    const play = (identity, element) => {
        if (typeof element.play !== 'function')
            return;
        // Автовоспроизведение может быть заблокировано до жеста пользователя —
        // в этом случае звук вернётся через resume() по AudioPlaybackStatusChanged.
        void Promise.resolve(element.play()).catch((error) => {
            pushCallDebugLog('subscribe', `Не удалось запустить воспроизведение аудио ${identity}: ${String(error?.message ?? error)}`, { identity }, 'warn');
        });
    };
    const detach = (identity) => {
        const current = attached.get(identity);
        if (!current)
            return;
        attached.delete(identity);
        try {
            current.track.detach(current.element);
        }
        catch (error) {
            console.warn(`Failed to detach remote audio for ${identity}`, error);
        }
        current.element.srcObject = null;
        current.element.remove();
    };
    const attach = (identity, track) => {
        const existing = attached.get(identity);
        if (existing?.track === track && existing.element.isConnected) {
            applySinkId(existing.element);
            play(identity, existing.element);
            return;
        }
        detach(identity);
        const container = getContainer();
        if (!container)
            return;
        const element = document.createElement('audio');
        element.autoplay = true;
        element.setAttribute('data-identity', identity);
        track.attach(element);
        applySinkId(element);
        container.appendChild(element);
        attached.set(identity, { element, track });
        play(identity, element);
    };
    return {
        attach,
        detach,
        setSinkId: (deviceId) => {
            sinkId = deviceId;
            attached.forEach(({ element }) => applySinkId(element));
        },
        resume: () => {
            attached.forEach(({ element }, identity) => play(identity, element));
        },
        clear: () => {
            Array.from(attached.keys()).forEach(detach);
            if (typeof document !== 'undefined') {
                document.getElementById(CONTAINER_ID)?.remove();
            }
        },
        getAttachedIdentities: () => Array.from(attached.keys()),
    };
}
